import { Shape } from 'app/features/shapeValidation/slice/types';
// Shapes
export const SHAPE_RING: Shape = 'ring';
export const SHAPE_DISC: Shape = 'disc';
export const SHAPE_FRAME: Shape = 'frame';
export const SHAPE_STRIP: Shape = 'strip';

// Validation
export const DECIMAL_NUMBERS_PATTERN = /^\d+(?:\.,\d{1,2})?$/;
export const WHOLE_NUMBERS_PATTERN = /^\d+(\.\d+)+$/;
export const NO_LETTERS_ALLOWED = /[A-Za-z]/;

// Payload
export const TARGET_SYSTEM = 'SEL_GAS';

export const URL_PATH = 'gasket-configurator';

// Shape Vizualization
export const MM_TO_PX_MULTIPLIER = 10;

// Video URLs
export const VIDEO_URL_BE: string = 'https://eriks.be/content/dam/be/videos';
export const VIDEO_URL_NL: string =
  'https://eriks.nl/content/dam/nl/assets-eriks-nl/video';

// Documents URLs
export const DOCUMENT_URL_BE: string =
  'https://eriks.be/content/dam/be/solutions/e-bizz-solutions';
export const DOCUMENT_URL_NL: string =
  'https://eriks.be/content/dam/be/solutions/e-bizz-solutions';
